'use strict';

var inStreetViewMode = false;
var hasPanoramaAvailable = false;
var panorama = null;
function updateMapUI(hasStreetViewAvailable, inStreetViewMode) {
    if (hasStreetViewAvailable) {
        jQuery('.gmap-switch').show();
    }
  else
  {
     jQuery('.gmap-switch').hide();
  }

    if (inStreetViewMode) {
        jQuery('.gmap-switch .gmap-to-map').show();
        jQuery('.gmap-switch .gmap-to-street').hide();
    } else {
        jQuery('.gmap-switch .gmap-to-map').hide();
        jQuery('.gmap-switch .gmap-to-street').show();
    }
}

function tryFindPanorama(panorama, point, radius, next) {
    var streetViewService = new google.maps.StreetViewService();
    streetViewService.getPanorama({location: point, radius: radius, preference: google.maps.StreetViewPreference.BEST},
        function (streetViewPanoramaData, status) {
            if (status === google.maps.StreetViewStatus.OK) {

                var oldPoint = point;
                point = streetViewPanoramaData.location.latLng;

                var heading = google.maps.geometry.spherical.computeHeading(point, oldPoint);            

                panorama.setPosition(point);
                //panorama.setPano(streetViewPanoramaData.location.pano);
                panorama.setPov({
                    heading: heading,
                    zoom: 0,
                    pitch: 0
                });
                panorama.setVisible(true);
                inStreetViewMode = true;
                hasPanoramaAvailable = true;
            } else {
                // no street view available in this range, or some error occurred
                console.log('No Street View is not available for distance ' + radius + 'm, remaining in maps mode.');
                if (next !== undefined) { next(); }
            }
            updateMapUI(hasPanoramaAvailable, inStreetViewMode);
        });    
}

function tryStreetView(point, gmap) {
    var streetViewMaxDistance = 70;

    panorama = gmap.getStreetView();
    panorama.setOptions({enableCloseButton: false, addressControl: false});
    tryFindPanorama(panorama, point, 35, function() {
        tryFindPanorama(panorama, point, streetViewMaxDistance);
    });
}

function initMapAndSetMarker(lat, lng) {
   var lat = parseFloat(document.getElementById('prdlat').value);
   var lng = parseFloat(document.getElementById('prdlng').value);
  // var center = { lat: lat, lng: lng };
    var center = new google.maps.LatLng(lat, lng);
  //var center = new google.maps.LatLng(26.245016, -81.577523);
    var map = new google.maps.Map(document.getElementById('googleMap'), {
        zoom: 18,
        center: center,
        mapTypeId: 'satellite',
        tilt: 45
    });
    map.setTilt(45);
    var marker = new google.maps.Marker({
        position: center,
        map: map
    });

    tryStreetView(center, map);
}

function toMapView() {
    if (panorama && inStreetViewMode)
    {
        inStreetViewMode = false;
        panorama.setVisible(inStreetViewMode);
    }
    updateMapUI(hasPanoramaAvailable, inStreetViewMode);
}

function toStreetView() {
  console.log("streetview");
    if (panorama && !inStreetViewMode && hasPanoramaAvailable)
    {
        inStreetViewMode = true;
        panorama.setVisible(inStreetViewMode);
    }
    updateMapUI(hasPanoramaAvailable, inStreetViewMode);
}